import * as ViewManagementModule from "Modules/ViewManagementModule";
import * as InvestmentEnumTypes from "./EnumTypes/InvestmentEnumTypes";
import { OptionsElement } from "Models/ViewManagementModel";

export const investmentTypeMap = new Map<
  InvestmentEnumTypes.InvestmentType,
  string
>([
  [InvestmentEnumTypes.InvestmentType.diamonds, "Diamenty"],
  [InvestmentEnumTypes.InvestmentType.dorm, "Akademik"],
  [InvestmentEnumTypes.InvestmentType.flat, "Nieruchomość"],
  [InvestmentEnumTypes.InvestmentType.gold, "Złoto"],
  [InvestmentEnumTypes.InvestmentType.hotel, "Hotel"],
  [InvestmentEnumTypes.InvestmentType.parcel, "Działka"],
  [InvestmentEnumTypes.InvestmentType.token, "Tokeny"],
  [InvestmentEnumTypes.InvestmentType.vehicle, "Samochód"],
  [InvestmentEnumTypes.InvestmentType.whisky, "Whisky"],
  [InvestmentEnumTypes.InvestmentType.franchise, "Franczyza"],
  [InvestmentEnumTypes.InvestmentType.artWork, "Dzieła sztuki"],
]);

export const investmentTypeArray = [
  InvestmentEnumTypes.InvestmentType.diamonds,
  InvestmentEnumTypes.InvestmentType.dorm,
  InvestmentEnumTypes.InvestmentType.flat,
  InvestmentEnumTypes.InvestmentType.gold,
  InvestmentEnumTypes.InvestmentType.hotel,
  InvestmentEnumTypes.InvestmentType.parcel,
  InvestmentEnumTypes.InvestmentType.token,
  InvestmentEnumTypes.InvestmentType.vehicle,
  InvestmentEnumTypes.InvestmentType.whisky,
  InvestmentEnumTypes.InvestmentType.franchise,
  InvestmentEnumTypes.InvestmentType.artWork,
];

export const RiskDegrees = [
  "Kruszce przechowywane samodzielnie przez Klienta.",
  "Kamienie szlachetne przechowywane samodzielnie przez Klienta.",
  "Inwestycje nieruchomościowe zabezpieczone hipotecznie z oddzielną księga wieczystą.",
  "Numizmatyka przechowywana samodzielnie przez Klienta.",
  "Inwestycje Handlowe zabezpieczone hipotecznie bez odrębnej księgi wieczystej, dzieła sztuki.",
  "Pojazdy przechowywane przez Klienta.",
  "Whisky przechowywana przez Klienta.",
  "Inwestycje nieruchomościowe bez zabezpieczenia hipotecznego.",
  "Inwestycje w biznes franczyzowy.",
  "Udziały w przedsiębiorstwach",
];
export const VoivodeshipsArray = [
  "dolnośląskie",
  "kujawsko-pomorskie",
  "lubelskie",
  "lubuskie",
  "łódzkie",
  "małopolskie",
  "mazowieckie",
  "opolskie",
  "podkarpackie",
  "podlaskie",
  "pomorskie",
  "śląskie",
  "świętokrzyskie",
  "warmińsko-mazurskie",
  "wielkopolskie",
  "zachodniopomorskie",
];

export const prefixOArray = [
  "+48 (Polska) ",
  "+44 (Wielka Brytania)",
  "+49 (Niemcy)",
];

export const RiskArray = [
  "1. Kruszce przechowywane samodzielnie przez Klienta.",
  "2. Kamienie szlachetne przechowywane samodzielnie przez Klienta.",
  '3. Inwestycje nieruchomościowe zabezpieczone hipotecznie z oddzielną księga wieczystą."',
  "4. Numizmatyka przechowywana samodzielnie przez Klienta.",
  "5. Inwestycje Handlowe zabezpieczone hipotecznie bez odrębnej księgi wieczystej, dzieła sztuki.",
  "6. Pojazdy przechowywane przez Klienta.",
  "7. Whisky przechowywana przez Klienta.",
  "8. Inwestycje nieruchomościowe bez zabezpieczenia hipotecznego.",
  "9. Inwestycje w biznes franczyzowy.",
  "10. Udziały w przedsiębiorstwach",
];
export const stopienRyzyka: Array<ViewManagementModule.Types.OptionsElement> = [
  {
    label: "DUZY",
    value: "DUZY",
  },
  {
    label: "OGROMNY",
    value: "OGROMNY",
  },
];
export const oprocentowanie: Array<ViewManagementModule.Types.OptionsElement> = [
  {
    label: "ENORMOUS",
    value: "ENORMOUS",
  },
  {
    label: "BIG",
    value: "BIG",
  },
];
export const duration: Array<ViewManagementModule.Types.OptionsElement> = [
  {
    label: "LONG",
    value: "LONG",
  },
  {
    label: "SHORT",
    value: "SHORT",
  },
];
export const premium: Array<ViewManagementModule.Types.OptionsElement> = [
  {
    label: "Zwykły",
    value: 0,
  },
  {
    label: "Premium",
    value: 1,
  },
];
export const legalFormOptions = [
  { label: "Prywatna", value: "private" },
  { label: "Firma", value: "company" },
];

function getOptionsList(
  arrayEnums: Array<any>,
  dictionary?: Map<any, any>
): Array<OptionsElement> {
  const optionsElement: Array<OptionsElement> = [];
  arrayEnums.map((value, i) => {
    optionsElement.push({
      label: dictionary ? dictionary.get(value) : value,
      value,
    });
  });
  return optionsElement;
}

function getOptionsRisk(
  arrayEnums: Array<any>,
  dictionary?: Map<any, any>
): Array<OptionsElement> {
  const optionsElement: Array<OptionsElement> = [];
  arrayEnums.map((value, i) => {
    optionsElement.push({
      label: dictionary ? dictionary.get(value) : value,
      value: i,
    });
  });
  return optionsElement;
}

export const getInvestmentOptions = getOptionsList(
  investmentTypeArray,
  investmentTypeMap
);
export const riskOptions = getOptionsRisk(RiskArray);
export const voivodeshipsOptions = getOptionsList(VoivodeshipsArray);
export const prefixOptions = getOptionsList(prefixOArray);

export const MappedErrorResponse = new Map<string, string>([
  ["Passwords not pass", "Hasła nie są takie same"],
  ["Username already exists", "Użytkownik już istnieje"],
]);



// WEBPACK FOOTER //
// ./src/Models/Dictionary.ts